import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Styles from '../../../GeneralUI/Styles';
import { Paper, InputLabel, Grid } from '@material-ui/core';
import Buttoncontrol from "../../../GeneralUI/Buttoncontrol";
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { TextField, Button } from '@material-ui/core';
import { SnackbarProvider, withSnackbar } from 'notistack';
import { errorSetter, combineStyles } from '../../../../Libs';
import AutoComplete from '../../../GeneralUI/AutoComplete';


const styles = theme => ({
  button: {
    margin: theme.spacing(),
  },
  input: {
    display: 'none',
  }
});

class OrdencargueModificaResolucion extends Component {
  constructor(props) {
    super(props);
    this.setErrors = errorSetter.setErrors.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    data: [],
    fields: {
      Resolucion: null,
      ordcarCodigo:null
    },
    responseForm: { Message: '', typeMessage: '' },
    formValidations: {view: []},
    formErrors: {    }
  };

  componentDidMount() {
    const params = this.props.match.params;
    if (!params.id) {
      return;
    }
  }

  handleSeguir = () => {
    alert('Seguimiento registrado.');
  }

  handleChange = (event) => {
    let { fields } = this.state;
    if (event.target.type === 'time') {
      fields[event.target.id] = event.target.value;
    } else if (event.target.type === 'number') {
      fields[event.target.id] = event.target.value;
    } else {
      fields[event.target.id] = event.target.value.toUpperCase();
    }

    if (fields[event.target.id] === '') {
      fields[event.target.id] = null;
    }

    this.setState({ fields });
  }

  save = (response) => {

    let newState={
      data: response.data,
      responseForm: response.responseForm
    };

    this.setState(newState);

    this.message(newState.responseForm['typeMessage'], newState.responseForm['Message']);
  }

  message = (type, message) => {
    this.props.enqueueSnackbar(message, { variant: type });
  }

  messageValidation = (type, message) => {
    this.message(type, message);
  }

  validaData = () => {
    let isvalid = true, message = 'El registro no ha sido guardado.', type = "warning";

    if ((this.state.fields.ordcarCodigo == null || !String(this.state.fields.ordcarCodigo).trim())) {
      message = "Debe diligenciar la Orden de cargue.";
      isvalid = false;
    }

    if ((this.state.fields.Resolucion == null || !String(this.state.fields.Resolucion).trim())) {
      message = "Debe diligenciar el campo Resolucion.";
      isvalid = false;
    }
    
    if (!isvalid) {
      this.message(type, message);
    }
    return isvalid;
  }

  render() {
    const { classes } = this.props;

    return (

      <Paper elevation={5} className={classes.mainPaper}>
        <form className={this.props.form} onSubmit={e => e.preventDefault()}>

          <Grid container spacing={3} className={classes.gridForm}>
            <InputLabel className={classes.tittleLabelForm}>
              Ordencargue Modifica Resolucion
            </InputLabel>
          </Grid>

          
          <Grid container spacing={2}>  
            <Grid item xs={3} className={classes.gridForm}>
              <AutoComplete
                id="ordcarCodigo"
                tableName='vw_ordencargue_interfaz'
                fields={['ORDCAR_CODIGO', 'RESOLUCION', 'CLIENTE']}
                aliases={[{ value: 'ID', size: 4 },  { value: 'RESOLUCION', size: 3 },  { value: 'Cliente', size: 5 }]}
                size='xl'
                primaryField='ORDCAR_CODIGO'
                searchField='RESOLUCION'
                isView={true}
                placeHolder='Ordencargue'
                onSelect={this.handleChange}
                value={this.state.fields["ordcarCodigo"]}
              />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <TextField id="Resolucion" label="Resolucion (*)" type="text"
                fullWidth margin="normal" variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["Resolucion"]}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>     
          </Grid>
        </form>

        <div id='buttonContainer'>
          <Buttoncontrol
            saveData={this.state}
            saveDataValidation={this.state.fields}
            moduleName='factura'
            save={this.save}
            validaData={this.validaData}
            messageValidation={this.messageValidation}
            primaryFields={['ordcarCodigo']}
            formValidations={this.state.formValidations}
            errorHandler={this.setErrors}
            url='/processes/ordencargue_modifica_resolucion' 
            isFormLite={true}
          />
        </div>

      </Paper>
    );
  }
}

OrdencargueModificaResolucion.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
};

const MyApp = withRouter(withSnackbar(withStyles(combineStyles(styles, Styles))(OrdencargueModificaResolucion)));

function IntegrationNotistack() {
  return (
    <SnackbarProvider key={6} maxSnack={1}
      action={[
        <Button key={6} variant="text" color="primary" size="small">
          {'X'}
        </Button>
      ]}
    >
      <MyApp />
    </SnackbarProvider>
  );
}


export default IntegrationNotistack;